import { render, staticRenderFns } from "./GamesBlockWithBigRightItem.vue?vue&type=template&id=7e63b13f&scoped=true&"
import script from "./GamesBlockWithBigRightItem.vue?vue&type=script&lang=js&"
export * from "./GamesBlockWithBigRightItem.vue?vue&type=script&lang=js&"
import style0 from "./GamesBlockWithBigRightItem.vue?vue&type=style&index=0&id=7e63b13f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e63b13f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e63b13f')) {
      api.createRecord('7e63b13f', component.options)
    } else {
      api.reload('7e63b13f', component.options)
    }
    module.hot.accept("./GamesBlockWithBigRightItem.vue?vue&type=template&id=7e63b13f&scoped=true&", function () {
      api.rerender('7e63b13f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/games/GamesBlockWithBigRightItem.vue"
export default component.exports